import mapKeys from 'lodash/mapKeys';

export function normalizeArrayToEntity(
  array: any[],
  identifier: string = 'id'
) {
  if (!Array.isArray(array)) {
    throw Error('data to normlize must be an array');
  }
  return {
    ids: array.map((ent) => ent[identifier]),
    entities: mapKeys(array, identifier),
  };
}
